import React from 'react';

const FetchingMessage = ({ symbol }) => {
  return (
    <div className="fetching-message">
      <div className="fetching-icon">⏳</div>
      <h3>Fetching data for {symbol}</h3>
      <p>We're retrieving information for this stock. This may take a moment...</p>
      <div className="loading-bar">
        <div className="loading-progress"></div>
      </div>
    </div>
  );
};

export default FetchingMessage;